import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PlantStatusService {

  constructor() { }

  getData(): number[] {
    return [3, 1, 1];
  }
}
